/* Da quale fonte verificare la copertura: SalesMate, il sito TIM, o lo decide chi lavora.

   Il telefono chiedeva SEMPRE la fonte al solo fatto di essere un agente, anche a chi non
   ha il permesso del sito TIM: scegliendola, il server rispondeva 403 (06/10/2026). Il
   desktop invece disegnava i pulsanti in base ai permessi. Due pagine, due idee diverse.
   Ora la regola e' una sola e sta qui. */

export function fonteCopertura(variant, caps) {
  const c = caps || {};
  if (variant !== 'agente') return 'salesmate';   // link collaboratore: solo SalesMate, invariato
  if (c.copertura && c.coperturatim) return 'scelta';
  if (c.coperturatim) return 'tim';
  return 'salesmate';
}
